import React from "react";
import {
  Page as PdfPage,
  Document,
  StyleSheet,
  View,
  Text,
  Image,
} from "@react-pdf/renderer";
import moment from "moment";
import { formatDistance, parseISO } from "date-fns";
import fulllogo from "../../images/fulllogo.png"; // Import the logo - adjust the path as needed

// Create styles
const styles = StyleSheet.create({
  logoImage: {
    width: 250, // Adjust width as needed
    marginBottom: 35,
  },
  page: {
    paddingLeft: 100,
    paddingRight: 100,
    paddingTop: 50,
    paddingBottom: 50,
    fontFamily: "Helvetica",
  },
  header: {
    marginBottom: 20,
    textAlign: "left",
  },
  logo: {
    fontSize: 28,
    fontWeight: "bold",
    marginBottom: 5,
  },
  
  title: {
    fontSize: 24,
    fontWeight: "bold",
    marginBottom: 5,
    // textDecoration: "underline",
    textAlign: "left",
  },
  infoRow: {
    flexDirection: "row",
    marginBottom: 35,
    fontSize: 18,
    alignItems: "center",
    justifyContent: "space-between",
  },
  label: {
    fontWeight: "bold",
    color: "#1f7e77",
    fontSize: 18,
  },
  value: {
    fontWeight: "bold",
  },
 
  section: {
    marginBottom: 15,
  },
  sectionTitle: {
    fontSize: 22,
    fontWeight: "bold",
    marginBottom: 15,
    backgroundColor: "#1f7e77",
    padding: 12,
    color: "#fff",
  },
  subsectionTitle: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 20,
    marginTop: 25,
  },
  subsectionTitleGreen: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 15,
    color: "#1f7e77",
  },
  listItem: {
    fontSize: 18,
    marginBottom: 3,
    marginLeft: 10,
  },
  chart: {
    width: "100%",
    height: 210,
    marginBottom: 10,
  },
});

const Header = () => (
  <View style={styles.header} fixed>
    {" "}
    {/* fixed makes it appear on every page */}
    <Image src={fulllogo} style={styles.logoImage} />
  </View>
);

const PageWithHeader = ({ children, ...props }) => (
  <PdfPage {...props}>
    <Header />
    <View style={styles.content}>{children}</View>
  </PdfPage>
);
const GroupSessionNotePDF = ({
  chartImages,
  session,
  concernImage,
  programDetails,
}) => {
  if (!session) {
    return null;
  }

  const stripHtml = (html) => {
    if (!html) return "";

    const items =
      html
        .match(/<li>(.*?)<\/li>/g)
        ?.map((item) => item.replace(/<\/?li>/g, "").trim()) || [];

    const hasUL = html.includes("<ul>") && html.includes("<li>");

    if (hasUL) {
      return items.map((item, index) => <Text key={index}>• {item}</Text>);
    } else if (html.includes("<p>")) {
      const paragraphs =
        html.match(/<p>(.*?)<\/p>/g)?.map((p) => {
          let clean = p.replace(/<\/?p>/g, "").replace(/&nbsp;/g, " ");
          clean = clean.replace(/[ÕÐÍº]/g, "-");
          return clean.trim();
        }) || [];
      return paragraphs.map((para, index) => <Text key={index}>{para}</Text>);
    } else {
      return <Text>{html}</Text>;
    }
  };
  return (
    <Document>
      <PageWithHeader size={[1270.8, 1812.24]} style={styles.page}>
        {/* <Page size={[1270.8, 1812.24]} style={styles.page}> */}
        {/* Header */}
        <View style={styles.header}>
          <Text style={styles.title}>Group Session Note</Text>
        </View>

        {/* Patient Information */}
        <View style={styles.infoRow}>
          <View style={{ display: "flex", flexDirection: "row", gap: 10 }}>
            <Text style={styles.label}>Program Title</Text>
            <Text style={styles.value}>{programDetails?.programName}</Text>
          </View>

          <View style={{ display: "flex", flexDirection: "row", gap: 10 }}>
            <Text style={styles.label}>Facilitator</Text>
            <Text style={styles.value}>{session?.session?.createdBy}</Text>
          </View>
        </View>

        <View style={styles.infoRow}>
          <View style={{ display: "flex", flexDirection: "row", gap: 10 }}>
            <Text style={styles.label}>Encounter type</Text>
            <Text style={styles.value}>{session?.session.title}</Text>
          </View>
          <View style={{ display: "flex", flexDirection: "row", gap: 10 }}>
            <Text style={styles.label}>Encounter Date</Text>
            <Text style={styles.value}>
              {moment(session?.session.sessionDate).format("DD MMMM, YYYY")}
            </Text>
          </View>
          <View style={{ display: "flex", flexDirection: "row", gap: 10 }}>
            <Text style={styles.label}>Duration</Text>
            <Text style={styles.value}>
              {
                Math.floor((new Date(session?.session?.endTime) - new Date(session?.session?.startTime)) / 60000)+" minutes"
              }
            </Text>
          </View>
        </View>

        <View style={styles.infoRow}>
          <View style={{ display: "flex", flexDirection: "row", gap: 10 }}>
            <Text style={styles.label}>Session Title</Text>
            <Text style={styles.value}>{session?.session.title}</Text>
          </View>
          <View style={{ display: "flex", flexDirection: "row", gap: 10 }}>
            <Text style={styles.label}>Number of Participants</Text>
            <Text style={styles.value}>
              {programDetails?.programMembers?.length}
            </Text>
            
          </View>
        </View>

        {/* Subjective Section */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Subjective</Text>

          <View
            style={{ flexDirection: "row", justifyContent: "space-between" }}
          >
            <Text style={styles.subsectionTitleGreen}>Reported Concerns</Text>
            <View style={{ width: "62%" }}>
              {session?.groupSession?.concerns.map((item, index) => (
                <View
                  key={index}
                  style={{ marginBottom: 25, flexDirection: "row" }}
                >
                  <Text style={{ fontSize: 18, fontWeight: "bold",marginRight:20 }}>
                    {String.fromCharCode(65 + index)}
                  </Text>
                  <Text style={{ fontSize: 18, backgroundColor: "#fcfcfc" }}>
                    {item.concern}
                  </Text>
                </View>
              ))}
            </View>
            <Text style={styles.subsectionTitleGreen}>Number of Members</Text>
            <View>
              {session?.groupSession?.concerns.map((item, index) => (
                <View key={index} style={{ marginBottom: 25 }}>
                  <Text style={{ fontSize: 16, backgroundColor: "#fcfcfc" }}>
                    {item.numberOfMembers}
                  </Text>
                </View>
              ))}
            </View>
          </View>
          <View style={{width:"100%",display:"flex",flexDirection:"row",gap:10,justifyContent:"center",alignItems:"center"}}>
            <Text style={{fontSize:14,fontWeight:"bold",color:"#1f7e77" }}>% of participants</Text>
            <View style={{width:"220px",display:"flex",flexDirection:"column",alignItems:"center"}}>
              {concernImage && (
                <Image style={styles.chart} src={concernImage} />
              )}
              <Text style={{fontSize:15,fontWeight:"bold",marginTop:10,color:"#1f7e77",textAlign:"center" }}>Concerns</Text>
            </View>
          </View>

        </View>

        {/* Objective Section */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Objective</Text>
          <Text style={styles.subsectionTitleGreen}>Group Health Metrics</Text>
          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "center",
              gap:30
            }}
          >
            {session?.groupSession?.healthMetrics?.map((item, index) => (
              <View style={{ width: "30%" }} key={index}>
                <Text style={{ fontSize: 16,color:"gray", fontWeight: "bold",marginBottom: 10,marginTop: 20}}>{item.value}</Text>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 10,
                    marginBottom: 20,
                  }}
                >
                  <Text style={{...styles.label,fontSize:15}}>{item.code}</Text>
                </View>
                {chartImages && (
                  <Image style={styles.chart} src={chartImages[index]} />
                )}
                <Text style={{textAlign:"center",fontSize:13}}>Members</Text>
              </View>
            ))}
          </View>

          <Text style={{ fontSize: 18,marginBottom: 20,marginTop: 25}}>Other Comments</Text>
          <View style={{ flexDirection: "column", gap: 10,marginBottom:50 }}>
            {stripHtml(session?.groupSession?.healthMetricsComments)}
          </View>
        </View>

        {/* Assessment Section */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Assessment</Text>
          <Text style={{fontSize: 18,marginBottom: 20,marginTop: 25}}>Clinical Summary & Key Takeaways</Text>
          <View style={{ flexDirection: "column", gap: 10,marginBottom:30 }}>
            {stripHtml(session?.groupSession?.assessmentComments)}
          </View>
        </View>

        {/* Plan Section */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Plan</Text>
          <View style={{ marginBottom: 20,display:"flex",flexDirection:"row" }}>
            {session?.groupSession?.carePlans?.map((plan, index) => (
              <Text key={index} style={{fontSize: 20, marginBottom: 20, marginTop: 25,border:"1px solid gray",padding:10,borderRadius:"5px",display:"inline-block"  }}>
                {plan.name}
              </Text>
            ))}
          </View>
          <Text
            style={{
              color: "#1f7e77",
              fontSize: 20,
              marginTop: 20,
              fontWeight: 600,
              fontFamily: "Helvetica",
            }}
          >
            Goals
          </Text>
          {session?.groupSession?.carePlans[0]?.goals?.map((goal, index) => (
            <View key={index} style={{ marginBottom: 20 }}>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: 10,
                  paddingTop: 20,
                }}
              >
                <View style={{ flexDirection: "row", gap: 10 }}>
                  <Text
                    style={{
                      ...styles.listItem,
                      marginLeft: 0,
                      fontWeight: 600,
                      fontFamily: "Helvetica",
                    }}
                  >
                    {index + 1 < 10 ? `0${index + 1}` : index + 1}
                  </Text>
                  {/* <Text style={{ ...styles.listItem,marginLeft:0, fontWeight: 600,fontFamily:"DejaVu Sans" }}>{index + 1 < 10 ? `0${index + 1}` : index + 1}</Text> */}
                  <Text style={{ ...styles.listItem, fontWeight: 600 }}>
                    {goal.goalName}
                  </Text>
                </View>
                <View style={{ flexDirection: "row", gap: 10 }}>
                  <Text
                    style={{ fontSize: 18, color: "#1f7e77", fontWeight: 600 }}
                  >
                    Duration
                  </Text>
                  <Text style={{ fontSize: 18, fontWeight: 600 }}>
                    {goal.duration} Days
                  </Text>
                </View>
              </View>

              <View style={{}}>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginBottom: 10,
                  }}
                >
                  <View>
                    <Text
                      style={{
                        ...styles.listItem,
                        fontWeight: 600,
                        marginBottom: 20,
                        marginLeft: 0,
                      }}
                    >
                      Tasks
                    </Text>
                    {goal.tasks?.map((task, taskIndex) => (
                      <Text
                        key={taskIndex}
                        style={{
                          ...styles.listItem,
                          color: "#666",
                          marginBottom: 10,
                          marginLeft: 0,
                        }}
                      >
                        {task.title}
                      </Text>
                    ))}
                  </View>
                  <View>
                    <Text
                      style={{
                        ...styles.listItem,
                        fontWeight: 600,
                        marginBottom: 20,
                      }}
                    >
                      Frequency
                    </Text>
                    {goal.tasks?.map((task, taskIndex) => (
                      <Text
                        key={taskIndex}
                        style={{
                          ...styles.listItem,
                          color: "#666",
                          marginBottom: 10,
                        }}
                      >
                        {task.frequency}
                      </Text>
                    ))}
                  </View>
                  <View>
                    <Text
                      style={{
                        ...styles.listItem,
                        fontWeight: 600,
                        marginBottom: 20,
                      }}
                    >
                      Priority
                    </Text>
                    {goal.tasks?.map((task, taskIndex) => (
                      <Text
                        key={taskIndex}
                        style={{
                          ...styles.listItem,
                          color: "#666",
                          marginBottom: 10,
                        }}
                      >
                        {task.priority}
                      </Text>
                    ))}
                  </View>
                </View>
              </View>
            </View>
          ))}

          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              marginTop: 20,
            }}
          >
            <View style={{ width: "48%" }}>
              <View style={{ flexDirection: "row" }}>
                <Image
                  src="images/Medications.png"
                  style={{ width: 18, height: 18 }}
                />
                <Text style={{ ...styles.listItem, color: "#1f7e77" }}>
                  Medications
                </Text>
              </View>

              {session?.groupSession?.carePlans[0]?.medications?.map(
                (med, index) => (
                  <View
                    key={index}
                    style={{ flexDirection: "row", gap: 10, marginTop: 10 }}
                  >
                    <Text style={styles.listItem}>
                      {med.medicineName.label}
                    </Text>
                    <Text style={styles.listItem}>{med.quantity}</Text>
                    <Text style={styles.listItem}>{med.schedule}</Text>
                  </View>
                )
              )}
            </View>
            <View style={{ width: "48%" }}>
              <View style={{ flexDirection: "row" }}>
                <Image
                  src="images/Supplements.png"
                  style={{ width: 25, height: 25 }}
                />
                <Text style={{ ...styles.listItem, color: "#1f7e77" }}>
                  Supplements
                </Text>
              </View>
              {session?.groupSession?.carePlans[0]?.supplements?.map(
                (supp, index) => (
                  <View
                    key={index}
                    style={{ flexDirection: "row", gap: 10, marginTop: 10 }}
                  >
                    <Text style={styles.listItem}>
                      {supp.supplementName.label}
                    </Text>
                    <Text style={styles.listItem}>{supp.quantity}</Text>
                    <Text style={styles.listItem}>{supp.schedule}</Text>
                  </View>
                )
              )}
            </View>
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              marginTop: 20,
            }}
          >
            <View style={{ marginTop: 20 }}>
              <View style={{ flexDirection: "row" }}>
                <Image
                  src="images/Meal-Plan.png"
                  style={{ width: 25, height: 25 }}
                />
                <Text style={{ ...styles.listItem, color: "#1f7e77" }}>
                  Meal Plan
                </Text>
              </View>

              <Text style={styles.listItem}>
                {session?.groupSession?.carePlans[0]?.mealPlan?.planName}
              </Text>
            </View>

            <View style={{ marginTop: 20 }}>
              <View style={{ flexDirection: "row" }}>
                <Image
                  src="images/Fitness-Plan.png"
                  style={{ width: 25, height: 25 }}
                />
                <Text style={{ ...styles.listItem, color: "#1f7e77" }}>
                  Fitness Plan
                </Text>
              </View>
              <Text style={styles.listItem}>
                {session?.groupSession?.carePlans[0]?.fitnessPlan?.planName}
              </Text>
            </View>

            <View style={{ marginTop: 20 }}>
              <View style={{ flexDirection: "row" }}>
                <Image
                  src="images/Affirmations.png"
                  style={{ width: 25, height: 25 }}
                />
                <Text style={{ ...styles.listItem, color: "#1f7e77" }}>
                  Affirmations
                </Text>
              </View>
              {session?.groupSession?.carePlans[0]?.affirmations?.map(
                (affirmation, index) => (
                  <Text key={index} style={styles.listItem}>
                    {affirmation}
                  </Text>
                )
              )}
            </View>
          </View>

          <View style={{ marginTop: 20 }}>
            <Text style={{fontSize: 18,marginBottom: 20,marginTop: 25}}>Other Comments</Text>
            {stripHtml(session?.groupSession?.carePlanComments)}
          </View>
        </View>
      </PageWithHeader>
    </Document>
  );
};

export default GroupSessionNotePDF;
